import * as m from '@/paraglide/messages';
import dashboard from '@listening/assets/astro/images/new-design-25/features-page/dashboard-features.png';
import featuresHeroMobile from '@listening/assets/astro/images/new-design-25/features-page/features-hero-mobile.png';

export function FeaturesHero() {
  return (
    <section
      className='mx-auto max-w-[1600px] px-4 sm:px-6 lg:px-8'
      itemScope
      itemType='http://schema.org/WebPageElement'
    >
      <div
        aria-labelledby='features-heading'
        className='flex flex-col items-center justify-center pt-20 pb-16 text-center sm:py-24 lg:pb-32'
        itemProp='mainContentOfPage'
      >
        <h1
          className='mb-4 text-4xl leading-[1.1] font-black text-black sm:mb-6 sm:text-5xl md:text-6xl lg:text-8xl'
          id='features-heading'
          itemProp='headline'
        >
          {m.features_hero_title()}
        </h1>
        <p
          className='mb-8 max-w-xl px-4 text-sm font-semibold text-neutral-665 sm:mb-12 sm:max-w-lg sm:text-lg lg:mb-16 lg:max-w-5xl lg:text-2xl'
          itemProp='description'
        >
          {m.features_hero_subtitle()}
        </p>
        <div
          aria-label='Interactive preview of our dashboard features'
          className='relative w-full px-4 sm:px-8 md:px-12'
          itemScope
          itemType='http://schema.org/ImageObject'
          role='img'
        >
          <div className='relative mx-auto max-w-[1600px]'>
            <img
              alt='Comprehensive view of our dashboard interface showing key features and analytics tools'
              className='hidden w-full md:block'
              height={900}
              src={dashboard}
              width={1600}
              // quality={100}
            />
            <img
              alt='Mobile view of our dashboard features'
              className='w-full md:hidden'
              height={900}
              src={featuresHeroMobile}
              width={600}
              // quality={100}
            />
            <div
              aria-hidden='true'
              className='absolute inset-x-0 bottom-0 h-24 rounded-b-lg bg-gradient-to-t from-white to-transparent sm:h-32'
            />
          </div>
        </div>
      </div>
    </section>
  );
}
